module.exports = __webpack_public_path__ + "assets/images/USD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD10.png
// module id = 1451
// module chunks = 1